import { Box, Checkbox, TextField, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import { DropdownFilterContainer, StyledMenuItem, StyledSelect } from "./Atom"
import { useEffect, useRef, useState } from "react"

const ProvidersHeaderSearchDropdownFilter = (props: any) => {
  const {
    id,
    disabled,
    handleFilter,
    placeholder,
    value,
    filterData,
    headerLabel,
  } = props

  const [filteredFilterData, setFilteredFilterData] = useState<Array<any>>([])

  const [open, setOpen] = useState(false)

  const ref = useRef(null)

  const onSearchFilterChange = (value: any) => {
    setFilteredFilterData(
      filterData?.filter((item: any) =>
        item?.label?.toLowerCase()?.includes(value?.toLowerCase()),
      ),
    )
  }

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    setFilteredFilterData([...filterData])
  }

  useEffect(() => {
    setFilteredFilterData([...filterData])
  }, [filterData])

  return (
    <DropdownFilterContainer>
      <Typography fontSize={10}>{headerLabel}</Typography>

      <StyledSelect
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        labelId="demo-multiple-name-label"
        id={`filter-${id}`}
        value={value}
        onChange={handleFilter}
        disabled={disabled}
        IconComponent={ExpandMoreIcon}
        displayEmpty
        renderValue={(selected: any): any => {
          return value ? `${value?.label}` : `${placeholder}`
        }}
      >
        <Box
          ref={ref}
          key={`search`}
          onClick={(e: any) => {
            e.preventDefault()
          }}
          sx={{
            maxHeight: "40px",
            // maxWidth: "160px",
            marginBottom: "10px",
            position: "sticky",
            top: "0px",
            backgroundColor: "#fff",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TextField
            //disabled={searchDisable}
            autoFocus
            placeholder="Search..."
            variant="outlined"
            size="small"
            onChange={(e: any) => onSearchFilterChange(e?.target?.value)}
            sx={{
              backgroundColor: "#fff",
              width: "180px",
            }}
            onKeyDown={(e: any) => {
              e.stopPropagation()
            }}
          />
        </Box>
        {filteredFilterData?.length ? (
          filteredFilterData?.map((item: any, index: number) => (
            <StyledMenuItem key={`${item?.label}-${id}-${index}`} value={item}>
              {item?.label}
            </StyledMenuItem>
          ))
        ) : (
          <StyledMenuItem disabled={true}>No Data</StyledMenuItem>
        )}
      </StyledSelect>
    </DropdownFilterContainer>
  )
}

export default ProvidersHeaderSearchDropdownFilter
